import GoogleMaps from "./maps/googlemaps";
import BingMaps from "./maps/bingmaps";
import GoogleStaticMaps from "./maps/googlestaticmaps";
export default class Maps {
    constructor() {
        this.elements = document.querySelectorAll(".maps");
        if (this.elements != null) {
            this.init();
        }
    }
    init() {
        this.elements.forEach(map => {
            let el = map.querySelector(".map-holder");
            let dataElement = map.querySelector(".map-data");
            let data = dataElement != null ? JSON.parse(dataElement.innerText) : null;
            if (data != null) {
                let map;
                switch (data.type) {
                    case "Google Maps":
                        map = new GoogleMaps();
                        break;
                    case "Google Static Map":
                        map = new GoogleStaticMaps();
                        break;
                    case "Bing Maps":
                        map = new BingMaps();
                        break;
                }
                map.load(data.key, el, data.lat, data.lng, data.zoom).then(() => {
                    for (let i = 0; i < data.markers.length; i++) {
                        let marker = data.markers[i];
                        map.addMarker(marker.lat, marker.lng, marker.title, marker.content, marker.icon, marker.iconX, marker.iconY);
                    }
                    map.render();
                });
            }
        });
    }
}
